import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/PropertyActions";


const initialState = {
    status: 200,
    isLoading: false,
    message: "",
    header: {},
    data: [],
    dataProperty: [],
    lastPage: false,
};

const PropertyStore = useGlobalHook(React, initialState, actions);

export default PropertyStore;
